import React from 'react';
import { Chip } from '@mui/material';

// Reusable badge component for Roth indicator
// Replaces hardcoded "** Roth contributions accepted" footnote
function VendorBadge({ show }) {
  if (!show) return null;

  return (
    <Chip
      label="Roth Accepted"
      size="small"
      sx={{
        fontSize: '0.75rem',
        fontWeight: 'bold',
        mt: 0.5,
        backgroundColor: '#e8f5e9',
        color: '#2e7d32',
        border: 'none'
      }}
    />
  );
}

export default VendorBadge;
